import $ from "jquery";

$(document).ready(function() {
    var $boxOutter = $('.box-outter');
    var $boxInner = $('.box-inner');

    if ($boxOutter.length && $boxInner.length) {
      var offsetTop = 100; // Distance from top of the page when the element becomes fixed
    
      $(window).on('scroll', function() {
        var scrollTop = $(window).scrollTop();
        var boxOutterOffset = $boxOutter.offset().top;
        var boxOutterHeight = $boxOutter.outerHeight();
        var boxInnerHeight = $boxInner.outerHeight();
    
        //console.log('Window scrollTop:', scrollTop);
        //console.log('boxOutter offset:', boxOutterOffset);
        //console.log('boxOutter height:', boxOutterHeight);
    
        // Check if we should fix the .box-inner when scrolling
        if (scrollTop > boxOutterOffset - offsetTop && scrollTop < (boxOutterOffset + boxOutterHeight - boxInnerHeight - offsetTop)) {
          //console.log('Box-inner is fixed');
          $boxInner.css({
            'position': 'fixed',
            'top': offsetTop + 'px',
            'width': $boxOutter.width() + 'px' // Maintain the same width
          });
        } else if (scrollTop >= (boxOutterOffset + boxOutterHeight - boxInnerHeight - offsetTop)) {
          // When the box-inner reaches the bottom of the box-outter
          //console.log('Box-inner reached the bottom');
          $boxInner.css({
            'position': 'absolute',
            'top': (boxOutterHeight - boxInnerHeight) + 'px',
            'width': '100%' // Reset width when it stops being fixed
          });
        } else {
          // Reset to normal positioning if before scrolling
          //console.log('Box-inner is in its original position');
          $boxInner.css({
            'position': 'relative',
            'top': '0',
            'width': '100%' // Reset width when not fixed
          });
        }
      });

    } else {
      
    }

    $(".copylink").click(function() {
        var pageURL = window.location.href;
      
        navigator.clipboard.writeText(pageURL)
            .then(function() {
                // Show the "Copied" message
                $("#copyMessage").fadeIn().delay(1000).fadeOut();
            })
            .catch(function(error) {
                console.error('Failed to copy page URL: ', error);
            });
      });

  });
  